import { TraceabilityBenefits } from './TraceabilityBenefits';

export type { TypeTraceabilityBenefitsProps } from './types';
export default TraceabilityBenefits;
